import Autocomplete from "../InputSuggestion/InputSuggestion";
import { memo } from "react";
const TableRow = ({
  item,
  tableItemIndex,
  changeRowColumn,
  setTableState,
  isTableEditable,
  setPlaying,
}) => {
  return (
    <>
      {item.row &&
        item.row.map((el, index) => (
          <td key={index} className="position-relative h-100">
            <Autocomplete
              key={index}
              index={index}
              rowId={el?.id}
              focus={el?.focus}
              mouseDownOnOption={el.mouseDownOnOption}
              rowType={el?.type}
              rowValue={el?.value}
              error={el?.error}
              isEditable={el?.isEditable}
              loading={el?.loading}
              showOptions={el?.showOptions}
              filteredOptions={el?.filteredOptions}
              selectedOptionIndex={el?.selectedOptionIndex}
              breakDownId={item?.id}
              options={el.possibleValues}
              handleLeftKeyPress={() =>
                changeRowColumn(tableItemIndex, index - 1)
              }
              handleRightKeyPress={() =>
                changeRowColumn(tableItemIndex, index + 1)
              }
              handleUpKeyPress={() =>
                changeRowColumn(tableItemIndex - 1, index)
              }
              handleDownKeyPress={() =>
                changeRowColumn(tableItemIndex + 1, index)
              }
              setTableState={setTableState}
              tableItemIndex={tableItemIndex}
              isTableEditable={isTableEditable}
              item={item}
              setPlaying={setPlaying}
            />
          </td>
        ))}
    </>
  );
};

export default memo(TableRow);
